// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"3c7e7b90","453":"a22a643b","927":"4241434d"}[chunkId] + ".chunk.js";
};